module.exports = __webpack_public_path__ + "img/b2.f7b37cba.png";